import { useContext } from 'react';
import DescriptionTemplatesContext from '../contexts/DescriptionTemplatesContext';

const useDescriptionTemplatesContext = () =>
  useContext(DescriptionTemplatesContext);

export default useDescriptionTemplatesContext;
